import script from "./SpecialAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpecialAction.vue?vue&type=script&setup=true&lang=ts"

import "./SpecialAction.vue?vue&type=style&index=0&id=2076d3bf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2076d3bf"]])

export default __exports__